import { IconPropsType } from '..';

export const ArrowLeftToLine = ({ ...props }: IconPropsType) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.499 12.483L8.94898 9.91802H16.0635V8.49002H8.94148L11.5065 5.92502L10.4925 4.91852L6.20698 9.20402L10.4925 13.4895L11.499 12.483ZM5.49898 13.4895V4.91852H4.06348V13.4895H5.49898Z" />
  </svg>
);
